import RestClient from "RestClient";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const restClient = new RestClient();

export const getSubscriptionList = async () => {
    const result = await restClient.get(`${BASE_URL}/subscriptions`);
    return result?.data; 
}
export const getFeatureList = async () => {
    const result = await restClient.get(`${BASE_URL}/features`);
    return result?.data; 
}
export const saveDetails = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/subscriptions/create`, payload);
    return result; 
}
export const saveFeatureText = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/subscriptions/createfeaturetext`, payload);
    return result; 
}
export const addFeature = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/features/create`, payload);
    return result; 
}
export const saveSubscription = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/usersubscriptions/create`, payload);
     console.log("aaa"+result);
    return result; 
}
export const scheduleDowngrade = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/stripe/scheduleDowngrade`, payload);
     console.log("aaa"+result);
    return result; 
}
export const getSubscription = async (id) => {
    const result = await restClient.get(`${BASE_URL}/usersubscriptions/${id}`);
    return result?.data; 
}
export const deleteSubscription = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/subscriptions/${id}`);
    return result?.data; 
}

export const createPayment = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/stripe/createPayment`,payload);
    return result?.data; 
}
export const verifyPayment = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/stripe/verifyPayment`,payload);
    return result?.data; 
}
export const getUserCounts = async () => {
    const result = await restClient.get(`${BASE_URL}/users/`);
    return result; 
}
export const updateStatus = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/usersubscriptions/status`, payload);
    return result; 
}
export const updateFreePlan = async (id,payload) => {
    const result = await restClient.put(`${BASE_URL}/usersubscriptions/updatePlan/${id}`, payload);
    return result; 
}
export const addCoupon = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/coupon/create`, payload);
    return result; 
}
export const fetchCoupons = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/coupon/list`, payload);
    return result; 
}
export const deleteCoupons = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/:id`);
    return result; 
}
export const editCoupons = async (code,payload) => {
    const result = await restClient.put(`${BASE_URL}/coupon/${code}`,payload);
    return result; 
}
export const deleteCoupon = async (code) => {
    const result = await restClient.delete(`${BASE_URL}/coupon/${code}`);
    return result; 
}
export const validateCoupon = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/coupon/validate/`,payload);
    return result; 
}